import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import HolidayManagementView from '../components/team-availability/HolidayManagementView';
import PaidTimeOffSettingsView from '../components/team-availability/PaidTimeOffSettingsView';

const TABS = [
  { value: 'holidays', label: 'Holidays' },
  { value: 'paid-time-off', label: 'Paid Time Off' },
];

export default function TeamAvailabilitySettings() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [activeTab, setActiveTab] = useState('holidays');

  if (loading) {
    return <div className="p-8 text-center text-gray-500">Loading...</div>;
  }

  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'ADMIN') return <Navigate to="/dashboard/team-availability" replace />;

  return (
    <div className="max-w-7xl mx-auto py-4 sm:py-6 px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4 sm:mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-gray-100 lg:text-gray-800">
            Team Availability Settings
          </h1>
          <p className="mt-1 text-sm text-gray-300 lg:text-gray-600">
            Manage company holidays and annual paid-time-off allowances.
          </p>
        </div>
        <button
          type="button"
          onClick={() => navigate('/dashboard/team-availability')}
          className="self-start sm:self-auto px-4 py-2 rounded-md text-sm font-medium bg-gray-200 text-gray-700 hover:bg-gray-300 transition-colors"
        >
          Back to Team Availability
        </button>
      </div>

      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex gap-8" aria-label="Team availability settings">
          {TABS.map((tab) => (
            <button
              key={tab.value}
              type="button"
              onClick={() => setActiveTab(tab.value)}
              className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === tab.value
                  ? 'border-sky-500 text-sky-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {activeTab === 'holidays' && <HolidayManagementView />}
      {activeTab === 'paid-time-off' && <PaidTimeOffSettingsView />}
    </div>
  );
}
